import { useState, useCallback } from 'react';
import { freeShippingBarApi } from '../api/freeShippingBar';
import type { FreeShippingBarSettings } from '../api/freeShippingBar';

export function useFreeShippingBar() {
  const [settings, setSettings] = useState<FreeShippingBarSettings | null>(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSettings = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await freeShippingBarApi.show();
      setSettings(res.data.data);
    } catch (err: any) {
      setError(err?.message ?? 'Failed to load free shipping bar settings.');
    } finally {
      setLoading(false);
    }
  }, []);

  const save = useCallback(async (next: FreeShippingBarSettings) => {
    setSaving(true);
    setError(null);
    try {
      const res = await freeShippingBarApi.update(next);
      setSettings(res.data.data);
      return res.data.data;
    } catch (err: any) {
      setError(err?.message ?? 'Failed to save free shipping bar settings.');
      return null;
    } finally {
      setSaving(false);
    }
  }, []);

  return { settings, loading, saving, error, fetchSettings, save, setError };
}
